import { useCallback, useState } from 'react'

export type AlertDialogState = {
  isOpen: boolean
  title: string
  message: string
  onSubmit: () => void | Promise<void>
  onClose?: () => void
}

export const useAlertDialogState = () => {
  const [alertDialogState, setAlertDialogState] =
    useState<AlertDialogState | null>(null)

  const openAlertDialog = useCallback(
    (state: Omit<AlertDialogState, 'isOpen'>) => {
      setAlertDialogState({
        ...state,
        isOpen: true,
      })
    },
    []
  )

  const closeAlertDialog = useCallback(() => {
    setAlertDialogState(null)
  }, [])

  const handleSubmit = useCallback(async () => {
    if (alertDialogState?.onSubmit) {
      await alertDialogState.onSubmit()
    }
    closeAlertDialog()
  }, [alertDialogState, closeAlertDialog])

  const handleClose = useCallback(() => {
    if (alertDialogState?.onClose) {
      alertDialogState.onClose()
    }
    closeAlertDialog()
  }, [alertDialogState, closeAlertDialog])

  return {
    alertDialogState,
    openAlertDialog,
    closeAlertDialog,
    handleSubmit,
    handleClose,
  }
}
